import React, { useState, useEffect } from "react";
import Button from "components/CustomButton";
import { ReactComponent as DownloadIcon } from "assets/img/icons/downloadIcon.svg";
import Loader from "components/Loader";
import fileDownload from "js-file-download";
import Axios from "axios";

const useStyle = {
  root: {
    height: "calc(100vh - 80px)",
    background: "#4f5058",
    borderRadius: "15px",
    border: "none",
    position: "relative",
    boxShadow: "0 4px 8px 0 rgb(0 0 0 / 20%), 0 6px 20px 0 rgb(0 0 0 / 19%)",
  },
  noPreviewContent: {
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    gap: "20px",
  },
  noPreviewText: {
    fontSize: "18px",
    color: "white",
    fontWeight: 300,
  },
  downloadContent: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "3px",
  },
  buttonStyle: {
    padding: 0,
    background:
      "transparent linear-gradient(103deg, #ffa100 0%, #ffc42f 52%, #ffe75e 100%) 0% 0% no-repeat padding-box",
    boxShadow: "1px 1px 10px #00000029",
    color: "#434343",
    width: "160px",
  },
  documentName: {
    position: "absolute",
    top: "10px",
    left: "10px",
    color: "white",
    fontSize: "18px",
  },
};

export default ({ documentSrc, documentName }) => {
  const classes = useStyle;
  const dontDisplayDocument = documentName.includes("csv");
  const [loading, setLoading] = useState(!dontDisplayDocument ? true : false);
  const loaderStyle = {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    height: "100%",
    alignItems: "center",
  };

  useEffect(() => {
    const timerID = setInterval(function () {
      try {
        var iframe = document.getElementById("iframe");
        //eslint-disable-next-line
        var iframeContext = iframe.contentWindow.document;
        iframe.src = `https://docs.google.com/gview?url=${documentSrc}&embedded=true`;
      } catch (e) {
        clearInterval(timerID);
      }
    }, 2000);

    return () => {
      clearInterval(timerID);
    };

    //eslint-disable-next-line
  }, [loading]);

  const downloadFile = () => {
    Axios.get(documentSrc, {
      responseType: "blob",
    }).then((res) => {
      fileDownload(res.data, documentName);
    });
  };
  return (
    <>
      <div style={classes.root}>
        <span style={classes.documentName}>{documentName}</span>
        {loading && (
          <div style={loaderStyle}>
            <Loader />
          </div>
        )}
        {!dontDisplayDocument && (
          <iframe
            style={{ paddingTop: "43px" }}
            title={"attachmentType"}
            name="frameName"
            width={"100%"}
            height={"100%"}
            id="iframe"
            onLoad={() => setLoading(false)}
            src={`https://docs.google.com/gview?url=${documentSrc}&embedded=true`}
          ></iframe>
        )}
        {dontDisplayDocument && (
          <div style={classes.noPreviewContent}>
            <span style={classes.noPreviewText}>No preview available</span>
            <Button
              onClick={downloadFile}
              type="button"
              buttonClass="light-gray-btn d-inline-block"
              buttonStyle={classes.buttonStyle}
            >
              <span style={classes.downloadContent}>
                <span>Download</span>
                <span>
                  <DownloadIcon style={{ width: "20px", height: "20px" }} />
                </span>
              </span>
            </Button>
          </div>
        )}
      </div>
    </>
  );
};
